import getReport from './create'

export const clickReport = (source: ClickSource) => {
  const $report = getReport()
  return $report({
    name: 'h5EventButtonChick',
    clickSource: source,
    round: window.inSDK ? 1 : 2,
  })
}
window.__clickReport__ = clickReport

export const shareReport = (shareWay: 'facebook' | 'twitter') => {
  const $report = getReport()
  return $report({
    name: 'h5EventShare',
    round: window.inSDK ? 1 : 2,
    shareWay,
  })
}
